import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme) {
  const isDarkMode = theme.palette.mode === 'dark';
  const brandGradient = theme.palette.gradients.brand;
  const brandHoverGradient = theme.palette.gradients.brandHover;
  const borderColor = alpha(theme.palette.primary.main, isDarkMode ? 0.5 : 0.35);
  const hoverShadow = isDarkMode
    ? '0 12px 24px rgba(2, 6, 23, 0.55)'
    : '0 10px 20px rgba(15, 23, 42, 0.25)';
  const disabledBg = alpha(theme.palette.primary.main, isDarkMode ? 0.22 : 0.32);

  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: theme.shape.borderRadius * 1.25,
          transition: theme.transitions.create([
            'background-color',
            'background-image',
            'box-shadow',
            'transform'
          ], {
            duration: theme.transitions.duration.shorter
          }),
          '&:hover': {
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          height: 48
        },
        contained: {
          color: theme.palette.common.white,
          backgroundImage: brandGradient,
          border: `1px solid ${borderColor}`,
          boxShadow: theme.customShadows?.z8 || '0 6px 20px rgba(15, 23, 42, 0.2)',
          '&:hover': {
            color: theme.palette.common.white,
            backgroundImage: brandHoverGradient,
            borderColor,
            transform: 'translateY(-1px)',
            boxShadow: hoverShadow
          },
          '&:active': {
            backgroundImage: brandHoverGradient,
            transform: 'translateY(0)'
          },
          '&.Mui-disabled': {
            color: alpha(theme.palette.common.white, 0.6),
            backgroundImage: 'none',
            backgroundColor: disabledBg,
            borderColor: alpha(disabledBg, 0.5),
            boxShadow: 'none'
          }
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        containedPrimary: {},
        containedSecondary: {},
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textPrimary: {
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08)
          }
        },
        textSecondary: {
          '&:hover': {
            backgroundColor: alpha(theme.palette.secondary.main, 0.08)
          }
        }
      }
    }
  };
}
